import { Helmet } from 'react-helmet-async';
import { useSiteData } from '@/hooks/useSiteData';
import { Header } from '@/components/layout/Header.tsx';
import { Welcome } from '@/components/sections/Welcome.tsx';
import { Footer } from '@/components/layout/Footer.tsx';

export function Index() {
  const { siteData } = useSiteData();

  return (
    <>
      <Helmet>
        <title>{siteData.title}</title>
        <meta name="description" content={siteData.description} />
        <meta name="keywords" content={siteData.keywords} />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={siteData.ogTitle} />
        <meta property="og:description" content={siteData.ogDescription} />
        <meta property="og:image" content={siteData.ogImage} />
        <meta property="og:url" content={siteData.canonicalUrl} />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={siteData.ogTitle} />
        <meta name="twitter:description" content={siteData.ogDescription} />
        <meta name="twitter:image" content={siteData.ogImage} />
        
        {/* Canonical URL */}
        <link rel="canonical" href={siteData.canonicalUrl} />
      </Helmet>
      
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1">
          <Welcome />
        </main>
        <Footer />
      </div>
    </>
  );
}